import { SET_LANGUAGE } from './types';

export default function user (state={}, action={}) {
    switch (action.type) {
        case SET_LANGUAGE :
            return action.language;
        default: return state;
    }
};
